const ReportsTestIdsScope = {
  VALIDATION_RULES_TABLE_ROW: 'validation-rules-table-row',
};

export const ReportsTestIds = {
  // Incomes
  INCOMES_SECTION: 'reports.incomes-section',
  INCOMES_TOGGLE_BUTTON: 'incomes-section.toggle-button',
  VALIDATION_RULES_TABLE_ROW_VALIDATION_RULES_TABLE: `${ReportsTestIdsScope.VALIDATION_RULES_TABLE_ROW}.validation-rules-table`,
  VALIDATION_RULES_TABLE_ROW_QUALIFIED_INCOMES_TABLE: `${ReportsTestIdsScope.VALIDATION_RULES_TABLE_ROW}.qualified-incomes-table`,
};
